<template>
  <div>
    <div class="resource-wrap" v-for="(item, index) in urlList" :key="index">
      <div class="pdf-wrap resource-box" v-if="checkType(item.path) == 'pdf'">
        <img src="@/static/images/cc_pdf_new.png" class="avatar" />
        <span class="file-name">{{ item.fileName }}</span>
        <div class="demo-upload-list-cover">
          <Icon class="ios-download-outline" type="ivu-icon ivu-icon-ios-eye-outline" @click.native="handleView(item.path)" />
        </div>
      </div>
      <div v-else class="resource-box">
        <img :src="item.path" :width="width" :height="height" :preview="_uid" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { urlList: Array, width: String, height: String },
  data() {
    return {
      show: false,
      srcImg: ''
    };
  },
  methods: {
    // 预览
    handleView(path) {
      if (this.checkType(path) == 'pdf') {
        window.open(path, '_blank');
      } else {
        location.href = path;
      }
    },

    // 获取文件类型
    checkType(path) {
      return path && path.split('.').pop().toLowerCase();
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  cursor: pointer;
}
.resource-wrap {
  display: inline-block;
  .resource-box {
    margin-right: 10px;
  }
  .pdf-wrap {
    width: 100px;
    height: 100px;
    position: relative;
    .file-name {
      position: absolute;
      bottom: 0;
      left: 0;
      display: inline-block;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.2);
      color: #fff;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 22px;
      font-size: 12px;
      padding: 0 4px;
    }
    img {
      width: 100%;
      height: 100%;
    }
    &:hover .demo-upload-list-cover {
      display: flex;
    }
  }
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  align-items: center;
  justify-content: center;
  z-index: 2;
  .ios-download-outline {
    z-index: 2;
    font-size: 30px;
    color: #fff;
  }
}
</style>